import SwiperElement from '@theme/base-swiper-element'

export class SwiperWithMedia extends SwiperElement {
  constructor() {
    super(...arguments)

    this.swiperOptions = {
      slidesPerView: 1,
      breakpoints: {},
      on: {
        slideChange: (swiper) => {
          swiper.slides.forEach((slideEl, index) => {
            if (index !== swiper.activeIndex) {
              this._stopMediaInSlide(slideEl)
            }
          })
        },
      },
    }
  }

  _stopMediaInSlide(slide) {
    const media = slide.querySelector('deferred-media')
    media?.pause()

    const inlineMedia = slide.querySelector('inline-media')
    if (inlineMedia) {
      inlineMedia.mute?.()
    }
  }

  connectedCallback() {
    super.connectedCallback()
    this._containerDialog = this.closest('modal-dialog')
    this._containerDialog?.addEventListener(
      'modal-dialog::close',
      this._handleContainerClose.bind(this)
    )
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    this._containerDialog?.removeEventListener(
      'modal-dialog::close',
      this._handleContainerClose.bind(this)
    )
  }

  _handleContainerClose() {
    this.swiperInstance.slides.forEach(this._stopMediaInSlide)
  }
}

customElements.define('swiper-with-media', SwiperWithMedia)
